import { render, staticRenderFns } from "./countdownWarranty.vue?vue&type=template&id=83fda6e2"
import script from "./countdownWarranty.vue?vue&type=script&lang=js"
export * from "./countdownWarranty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports